/**
 * Interaction Mode Registry
 */

import type { InteractionEntry } from './core';

export const INTERACTION_MODE_REGISTRY = [
  { id: 'none', label: 'No UI', description: 'Immediate action — no user interaction before handler runs', configSchema: [], hasInputFields: false, hasSurface: false },
  { id: 'confirm', label: 'Confirmation popup', description: 'Show a confirmation dialog before proceeding', configSchema: [{ key: 'message', type: 'text', label: 'Confirmation message', placeholder: 'Are you sure?', defaultValue: 'Are you sure you want to proceed?' }], hasInputFields: false, hasSurface: false },
  { id: 'review', label: 'Review', description: 'Editable form — auto-adapts to side-by-side diff layout when fields have current values', configSchema: [], hasInputFields: true, hasSurface: true },
  { id: 'review_single', label: 'Review (single form)', description: 'Editable form seeded with the proposed values — one column, never a side-by-side diff', configSchema: [], hasInputFields: true, hasSurface: true },
  { id: 'chat', label: 'AI Chat', description: 'Open the AI chat panel with artifact context', configSchema: [{ key: 'promptTemplate', type: 'textarea', label: 'Prompt template', placeholder: 'Describe the task for AI...', defaultValue: '' }], hasInputFields: false, hasSurface: true },
] as const satisfies readonly InteractionEntry[];

export type Interaction = (typeof INTERACTION_MODE_REGISTRY)[number]['id'];

/** Interaction modes that have a dedicated surface (hasSurface: true). */
export type SurfaceInteraction = Extract<(typeof INTERACTION_MODE_REGISTRY)[number], { hasSurface: true }>['id'];

export function getInteractionEntry(id: Interaction | (string & {})): InteractionEntry | undefined {
  return (INTERACTION_MODE_REGISTRY as readonly InteractionEntry[]).find((e) => e.id === id);
}

/** Narrow a free-text interaction id (a DB column) to a registry id; undefined when unknown. */
export function toKnownInteraction(id: string): Interaction | undefined {
  return INTERACTION_MODE_REGISTRY.find((e) => e.id === id)?.id;
}
